import { createStyles, HawkinsGlobalClass, makeStyles } from '@hawkins/styles';
export function textLinkStyles(theme) {
    var _a, _b, _c, _d;
    var hawkins = theme.hawkins, hawkinsUtils = theme.hawkinsUtils, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the root element when the component is active. */
        active: {},
        /** Class name of the root element. */
        root: (_a = {
                alignItems: 'center',
                columnGap: hawkinsVariables.spacings.space0,
                cursor: 'pointer',
                display: 'inline-flex',
                fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
                fontSize: hawkins.body.fontSize0,
                textDecoration: 'underline',
                textDecorationThickness: 1
            },
            _a["&.".concat(HawkinsGlobalClass.FOCUSABLE)] = (_b = {},
                _b[hawkinsUtils.getFocusRingedElementSelector('&', '::after')] = hawkinsUtils.getFocusRingPosition(2),
                _b),
            _a),
        /** Class name of the root element when the component is disabled. */
        rootDisabled: {
            cursor: 'not-allowed',
        },
        /** Class name of the root element when the component is not disabled. */
        rootEnabled: (_c = {},
            _c[hawkinsUtils.getHoveredElementSelector('&')] = { textDecorationThickness: 2 },
            _c),
        /** Class name of the root element in the normal variant. */
        rootNormal: {
            color: hawkins.textColor.textColorRegular,
        },
        /** Class name of the root element in the normal variant when disabled. */
        rootNormalDisabled: (_d = {
                color: hawkins.textColor.textColorXlight
            },
            _d["&.".concat(HawkinsGlobalClass.SELECTED)] = { color: hawkins.textColor.textColorRegular },
            _d),
        /** Class name of the root element when the no-wrap feature is enabled. */
        rootNoWrap: {
            display: 'inline-block',
        },
        /** Class name of the root element when bold is true */
        rootBold: {
            fontWeight: hawkinsVariables.fontWeights.fontWeight1,
        },
        /** Class name of the root element in the standalone variant. */
        rootStandalone: {
            color: hawkins.textColor.textColorInteractiveRegular,
            fontWeight: hawkinsVariables.fontWeights.fontWeight1,
        },
        /** Class name of the root element in the standalone variant when disabled. */
        rootStandaloneDisabled: {
            color: hawkins.textColor.textColorInteractiveXlight,
        },
    });
}
export var useTextLinkStyles = makeStyles(textLinkStyles, { name: 'Hawkins-TextLink' });
